import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { OrderWizardDataV26Service } from 'src/app/services-v26/wizards/order-wizard-data-v26.service';
import * as CopyAssetWizardActionsV26 from './actions';

@Injectable()
export class CopyAssetWizardEffectsV26 {
  newOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CopyAssetWizardActionsV26.createNewCopyAsset),
      concatMap(({ newOrder }) =>
        this.productWizardService.copyProductServices(newOrder).pipe(
          map((response) => {
            if (response) {
              return CopyAssetWizardActionsV26.createNewOrderSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(CopyAssetWizardActionsV26.createNewOrderFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private productWizardService: OrderWizardDataV26Service,
  ) {}
}
